/**
 * author antoine.nivet
 */
export default function toTrustedHtml($sce) {
  return function(value) {
    return $sce.trustAsHtml(value);
  };
}



// WEBPACK FOOTER //
// ./src/app/common/html.filter.js